<app-form-input
	[parentForm]="parentForm"

	[disabled]="disabled"
	[value]="estimationValeur?.valeur"

	[label]="step4.valeur"
	[type]="'number'"
	[rule]="'digits_2'"
	[name]="getUid() + '_SepAtt_valeur'"
>
</app-form-input>
<app-form-input-error [activeForm]="parentForm" [name]="getStepId() + rg1 + i" [id]="getStepId() + rg1 + i"></app-form-input-error>

<!---->

<app-form-input
	[parentForm]="parentForm"

	[disabled]="disabled"
	[value]="estimationValeur?.devise"
	[type]="'autocomplete'"
	[autoCompleteType]="'DEVISE'"
	[autoCompleteTypeIndex]="0"
	[label]="step4.devise"
	[rule]="'pattern_13'"
	[errorMessage]="{'pattern' : 'ctr_pattern_13'}"
	[name]="getUid() + '_SepAtt_devise'"
>
</app-form-input>
<app-form-input-error [activeForm]="parentForm" [name]="getStepId() + rg2 +i" [id]="getStepId() + rg2 +i"></app-form-input-error>